// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YcJ2wT8lLQ7wY6 {
  display: flex;
  flex-flow: row wrap;
  min-height: 26px;
}
.oPz6HcNyhzuU0Y {
  align-items: center;
  height: 100%;
  min-height: 0;
  margin-top: var(--ds-space-100, 8px);
  margin-left: var(--ds-space-050, 4px);
  line-height: 0;
}
.oPz6HcNyhzuU0Y.MMIj7U7I2Pzhmo {
  margin-top: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var reactionPiles = `YcJ2wT8lLQ7wY6`;
export var empty = `oPz6HcNyhzuU0Y`;
export var cardBack = `MMIj7U7I2Pzhmo`;
export default ___CSS_LOADER_EXPORT___;
